<script>
import VLink from '@/components/UI/Navigation/Link';

const VMenu = () => import('@/components/UI/Navigation/Menu');

export default {
  name: 'NavigationAutoflat',

  functional: true,

  props: {
    isNavigationFlat: {
      type: Boolean,
      required: true,
    },

    expanded: {
      type: String,
      required: false,
      default: null,
    },

    items: {
      type: Array,
      required: true,
    },
  },

  render: (h, ctx) => {
    const navigation = ctx.props.items;

    navigation.forEach(to => {
      to.link = h(VLink, {
        props: {
          to,
        },
      });
    });

    if (ctx.props.isNavigationFlat) {
      return navigation.map(n => n.link); // return flat list
    }

    // otherwise map to groups
    const groups = {};
    navigation.forEach(n => {
      if (!groups[n.parent]) groups[n.parent] = [];
      groups[n.parent].push(n.link);
    });

    const items = [];
    Object.keys(groups).forEach(group => {
      items.push(
        h(
          VMenu,
          {
            props: {
              name: ctx.parent.$t(`common.navigation_${group}`),
              group,
              expanded: ctx.props.expanded,
            },
            on: ctx.listeners,
          },
          groups[group]
        )
      );
    });

    return items;
  },
};
</script>
